import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  corpoFormulario: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(2),
  },
  groupFiliacao: {
    marginBottom: theme.spacing(2),
  },
  botaoAddFiliacao: {
    marginLeft: theme.spacing(1),
  },
  inputForm: {
    marginTop: theme.spacing(1.5),
  },
  field: {
    marginBottom: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 40,
  },
  divider: {
    margin: '40px 0 24px 0',
    height: '1px',
    backgroundColor: theme.palette.divider,
  },
  navigationContainer: {
    padding: '8px 4px',
  },
}))
